import request from '@/http/http';

export function getNavMenuFunction(){
    return request({
        url: 'nav/menu',
        method: 'get'
    })
}